import Vue from 'vue'

export const TagList = function (params) {
  return Vue.prototype.$axios.get(`/shop/tag/show/list?townId=${params}`)
}

export const fetchCaseList = function (params) {
  // return Vue.prototype.$axios.get('/app-store/benchmarking/case/list')
  return Vue.prototype.$axios.get('/solutionExcellent/getSolutionExcellentIndex')
}

export const fetchCasePage = function (params) {
  // return Vue.prototype.$axios.get(`/app-store/benchmarking/case/page?p=${params.p}&c=${params.c}&manage=${params.manage}`)
  return Vue.prototype.$axios.get(`/solutionExcellent/getSolutionExcellentList?p=${params.p}&c=${params.c}`)
}

export const fetchCaseInfo = function (params) {
  return Vue.prototype.$axios.post('/app-store/benchmarking/case/info', params)
}

export const pay = function (params) {
  return Vue.prototype.$axios.post('/shop/apply/pay', params)
}

export const payLiantong = function (params) {
  return Vue.prototype.$axios.post('/shop/apply/channel/sync', params)
}

export const getHotKeyword = function (params) {
  return Vue.prototype.$axios.get('/shop/apply/hot/keywords')
}

export const getCaseDetail = function (id) {
  return Vue.prototype.$axios.get('/benchmarking-case/detail/' + id)
}

export const getBannerList = function (assignId) {
  return Vue.prototype.$axios.get('/banner/list?assignId=' + assignId)
}

export const getBannerPage = function (params) {
  return Vue.prototype.$axios.get(`/banner/page?p=${params.p}&c=${params.c}&assignId=${params.assignId}`)
}

export const getQualityList = function (params) {
  return Vue.prototype.$axios.get(`/app-store/quality/list?type=${params.type}`)
}

export const getArtcileDetail = function (id) {
  return Vue.prototype.$axios.get('/article/detail/' + id)
}

export const getCommercialDetail = function (id) {
  return Vue.prototype.$axios.get('/business-format/detail/' + id)
}

export const getCommercialList = function (params) {
  return Vue.prototype.$axios.post(`/business-format/page?p=${params.p}&c=${params.c}`, params)
}

export const getModulesList = function (params) {
  return Vue.prototype.$axios.get('/shop/index/modules')
}

export const getSearch = function (params) {
  return Vue.prototype.$axios.post(`/shop/apply/list?p=${params.p}&c=${params.c}`, params)
}

export const getSearchSolution = function (params) {
  return Vue.prototype.$axios.post(`shop/solution/list?p=${params.p || 1}&c=${params.c || 6}`, params)
}

export const getChannelByCode = function (code) {
  return Vue.prototype.$axios.get('/app-store/channel/code/' + code)
}

export const getSolutionDetail = function (params) {
  return Vue.prototype.$axios.get(`shop/solution/getSolutionInfo?solutionId=${params.solutionId}&solutionRecordId=${params.solutionRecordId}`)
}



// WEBPACK FOOTER //
// ./src/services/home.js